const StagingBanner = () => (
  <div className='staging_banner'>
    <i className="fas fa-fw fa-exclamation-triangle" />
    <p>يرجى ملاحظة أن هذه النسخة من منصة كويندا للتجريب فقط، ولا تؤدي الحجوزات هنا إلى حجوزات فعلية.</p>
  </div>
);

export default StagingBanner;
